import NotificationTodo from './widgets/NotificationTodo';

export const Widgets = {
  NEW_TODOS: {
    title: () => 'New to-do assigned',
    icon: () => 'checkmark-square-outline',
    component: NotificationTodo,
  },
};
